import React, { PropTypes } from "react";
import { Field } from "redux-form";
import { FormattedMessage } from "react-intl";

import { TextInput } from "../../../../../../common/form";

const FixedFormula = (props) => {
  return (
    <div className="formula dollar">
      <Field
        id="formulaVolume"
        name="formulaVolume"
        component={TextInput}
        required={true}
        type="absNumber"
        readOnly={props.readOnly}
        label={<FormattedMessage id="clientCoverages.form.formulaVolume" />}
      />

      <Field
        id="invoicedClientRate"
        name="invoicedClientRate"
        component={TextInput}
        type="absNumber"
        readOnly={props.readOnly}
        label={
          <FormattedMessage
            id={`clientCoverages.form.invoicedClientRate.${props.ratePeriodType}`}
          />
        }
      />

      <Field
        id="clientRate"
        name="clientRate"
        component={TextInput}
        type="absNumber"
        readOnly={props.readOnly}
        label={
          <FormattedMessage
            id={`clientCoverages.form.clientRate.${props.ratePeriodType}`}
          />
        }
        onBlur={props.onChangeClientRate.bind(null, "clientRate")}
      />

      <Field
        id="providerRate"
        name="providerRate"
        component={TextInput}
        type="absNumber"
        readOnly="readonly"
        label={
          <FormattedMessage
            id={`clientCoverages.form.providerRate.${props.ratePeriodType}`}
          />
        }
      />
    </div>
  );
};

FixedFormula.propTypes = {
  onChangeClientRate: PropTypes.func,
  ratePeriodType: PropTypes.string,
  readOnly: PropTypes.bool,
};

export default FixedFormula;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/client-coverages/priceCalculation/formulas/FixedFormula.js